import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';
import { ResourceApi } from 'src/app/shared/apis/resource.api';
import { BannerList } from 'src/app/shared/interfaces/resource.interface';
import { ResponseData } from 'src/app/shared/interfaces/response.interface';
import { cacheValue } from 'src/app/shared/service/general.service';
import { KycService } from '../kyc/kyc.service';
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DividendVipService {
  /** 当前是否认证*/
  kycStatus: boolean = false;

  /** 活动列表订阅 */
  getActivitiesList$!: Observable<any>;
  /** 活动Banner订阅 */
  getActivitiesBannerList$?: Observable<ResponseData<BannerList[]>>;

  constructor(
    private kycService: KycService,
    private appService: AppService,
    private bounsApi: BonusApi,
    private resourceApi: ResourceApi
  ) {
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(x => {
      if (x?.kycGrade) {
        this.kycService.checkUserKycLevel(x.kycGrade).level > 0 && (this.kycStatus = true);
      }
    });
  }

  /**
   * 缓存活动列表
   *
   * @param params
   */
  public getActivitiesList(params: any) {
    return (
      this.getActivitiesList$ ??
      ((this.getActivitiesList$ = this.bounsApi.getActivityInfo(params).pipe(cacheValue(1000 * 60 * 10))),
      this.getActivitiesList$)
    );
  }

  /**
   * 缓存活动banner
   *
   * @param params
   * @param params.equipment
   * @param params.bannerPageType
   */
  public getActivitiesBannersList(params: {
    bannerPageType: 'FrontPage' | 'GamesPage' | 'LotteryPage' | 'Promotion';
    equipment: string;
  }) {
    return (
      this.getActivitiesBannerList$ ??
      ((this.getActivitiesBannerList$ = this.resourceApi
        .getbannerlist(params.bannerPageType, params.equipment)
        .pipe(cacheValue(1000 * 60 * 10))),
      this.getActivitiesBannerList$)
    );
  }
}
